import i18next from "i18next";
import { formatCalculationResult } from "services/common/CalculatorUtils";
import { setDocTypeTranslation } from "services/common/DocumentUtils";

/** Truncate 9-char hex color (#RRGGBBAA) to 7-char (#RRGGBB) */
export const normColor = (c) => (c?.length === 9 ? c.slice(0, 7) : c) || null;

/** Format a date string as "01 janv. 2025" (locale fr-FR, short month) */
export function formatDt(d) {
  if (!d) return "—";
  return new Date(d).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" });
}

/** Map raw indicators to { label, value, color } for display */
export const formatIndicators = (indicators) =>
  (indicators ?? [])
    .map((ind) => {
      const val = formatCalculationResult(ind);
      const dv = val === true ? i18next.t("yes") : val === false ? i18next.t("no") : val;
      return dv || dv === 0 ? { label: ind.label || ind.name, value: dv, color: normColor(ind.resultColorCode) } : null;
    })
    .filter(Boolean);

/**
 * Merge evidences + historicEvidences from dossier documents, then apply docType translations.
 * @param {Array} documents - raw documents array from dossier API
 * @param {Array} doctypeTraductions - from state.doctypeTraductions
 * @param {string} lang - current language code
 * @returns {Array} formatted documents with translated names
 */
export function transformDocuments(documents, doctypeTraductions, lang) {
  const raw = (documents ?? []).map((doc) => {
    const allEvidences = [].concat(
      doc.evidences ?? [],
      (doc.historicEvidences ?? []).filter((e) => e.statusReason !== "ARRET_DEMANDE"),
    );
    const first = allEvidences[0];
    const reponseId = first?.responseId;
    const fileId = first?.id;
    return {
      ...doc,
      present: allEvidences.length > 0,
      depositDate: first?.uploadDate,
      endDate: first?.expirationDate,
      reponseId,
      fileId,
      statusCode: doc.statusCode,
      typeDocumentId: doc.typeDocumentId,
      evidences: allEvidences,
      canOpen: !!(reponseId || fileId || doc.hasRefusedToFile),
    };
  });
  const translated = doctypeTraductions?.length > 0
    ? setDocTypeTranslation(doctypeTraductions, raw, lang)
    : raw;
  return (translated ?? raw).map((doc) => ({ ...doc, documentName: doc.translatedName || doc.documentName }));
}
